import TextWinds from '../../../components/common/TextWinds';
import '../../../styles/mypage/mypage.css';
import { orderDetailType } from '../../../constants/types/mypage-type';
import { numberWithCommas } from '../../../api/utils/format/numbers';
import { getLatestTransaction } from '../../../api/utils/order-item-transaction';
import { TransactionStatusLabelEnum } from '../../../enum';
import OrderDetailLayout, {
  OrderDetailDivider,
  OrderDetailRow,
} from './OrderDetailLayout';
import { useMemo } from 'react';

const PaymentDetail = ({ orderDetail }: { orderDetail: orderDetailType }) => {
  const paymentType = useMemo(() => {
    switch (orderDetail.payment_method) {
      case 'CREDIT_CARD':
        return '신용카드 결제';
      case 'DEPOSIT':
        return '무통장 입금';
      case 'POINT':
        return '포인트 결제';
      case 'BANK_TRANSFER':
        return '계좌 이체';
      default:
        console.error(orderDetail.payment_method);
        return '결제수단 확인 불가';
    }
  }, [orderDetail.payment_method]);
  const latestTransaction = getLatestTransaction(orderDetail.transactions);

  return (
    <OrderDetailLayout title="결제 정보">
      <div className="flex items-center justify-between font-bold">
        <div>총 결제 금액</div>
        <div>{numberWithCommas(orderDetail.template.total_price)} 원</div>
      </div>
      {/* 총 상품 금액 */}
      <OrderDetailRow
        label="상품 금액"
        value={
          <TextWinds type="content_body4">
            {numberWithCommas(
              orderDetail.template.total_price +
                orderDetail.template.discount_summary.total_discount -
                orderDetail.template.shipping_fee,
            )}{' '}
            원
          </TextWinds>
        }
      />
      {/* 할인 가격 */}
      <OrderDetailRow
        label="할인 가격"
        value={
          <TextWinds type="content_body4">
            {numberWithCommas(
              -orderDetail.template.discount_summary.total_discount,
            )}{' '}
            원
          </TextWinds>
        }
      />
      {/* 배송비 */}
      <OrderDetailRow
        label="배송비"
        value={
          <TextWinds type="content_body4">
            {numberWithCommas(orderDetail.template.shipping_fee)} 원
          </TextWinds>
        }
      />
      {/* 구분선 */}
      <OrderDetailDivider />

      {/* 포인트 - 0 이상인 경우 표시 */}
      {orderDetail.point_used && orderDetail.point_used > 0 ? (
        <OrderDetailRow
          label="포인트 사용"
          value={
            <TextWinds type="content_body4">
              {numberWithCommas(
                orderDetail.point_used ? orderDetail.point_used : 0,
              )}
              {' 점'}
            </TextWinds>
          }
        />
      ) : null}
      {/* 결제 금액 */}
      <OrderDetailRow
        label="결제 금액"
        value={
          <TextWinds type="content_body4">
            {numberWithCommas(
              orderDetail.template.total_price -
                (orderDetail.point_used ? orderDetail.point_used : 0),
            )}
            {' 원'}
          </TextWinds>
        }
      />
      <OrderDetailRow
        label="결제 수단"
        value={<TextWinds type="content_body4">{paymentType}</TextWinds>}
      />
      <OrderDetailRow
        label="처리 상태"
        value={
          <TextWinds type="content_body4">
            {latestTransaction.method === 'DEPOSIT' ? '입금 ' : '승인 '}
            {TransactionStatusLabelEnum[latestTransaction.status]}
          </TextWinds>
        }
      />

      {latestTransaction.status === 'DEPOSIT_REQUESTED' && (
        <>
          <OrderDetailRow
            label="예금주"
            value={
              <TextWinds type="content_body4">
                {latestTransaction.depositName ?? '-'}
              </TextWinds>
            }
          />
          <OrderDetailRow
            label="입금계좌"
            value={
              <TextWinds type="content_body4">
                {latestTransaction.bankName ?? '-'}{' '}
                {latestTransaction.accountNo}
              </TextWinds>
            }
          />
          <OrderDetailRow
            label="입금기한"
            value={
              <TextWinds type="content_body4">
                {latestTransaction.expiryDate ?? '-'}
              </TextWinds>
            }
          />
        </>
      )}
    </OrderDetailLayout>
  );
};

export default PaymentDetail;
